import * as Icons from "lucide-react";
import Reveal from "./Reveal";
import { AMENITIES, CONTACT } from "@/data/content";

export default function Amenities() {
    return (
        <section
            id="wohnung"
            data-testid="amenities-section"
            className="section-y bg-muted/50 relative"
        >
            <div className="container-em">
                <div className="max-w-3xl">
                    <Reveal>
                        <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                            Die Ferienwohnung
                        </span>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <h2
                            data-testid="amenities-title"
                            className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl leading-tight tracking-tight text-balance"
                        >
                            Das erwartet Dich.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 text-foreground/70 text-lg leading-relaxed max-w-2xl">
                            88 m² Wohnfläche für Deinen Aufenthalt – durchdacht
                            eingerichtet, mit allem, was Du zum Wohlfühlen
                            brauchst. Für einen Kurztrip genauso wie für längere
                            Zeit.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-5">
                    {AMENITIES.map((a, i) => {
                        const Icon = Icons[a.icon] || Icons.Check;
                        return (
                            <Reveal
                                key={a.label}
                                delay={i * 0.03}
                                y={16}
                                className="h-full"
                            >
                                <div
                                    data-testid="amenity-card"
                                    className="group h-full bg-card rounded-2xl p-5 sm:p-6 border border-border/60 hover:border-primary/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_-12px_rgba(60,60,50,0.18)]"
                                >
                                    <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-4 transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                                        <Icon size={20} strokeWidth={1.6} />
                                    </div>
                                    <p className="text-foreground/85 text-sm sm:text-base font-medium leading-snug">
                                        {a.label}
                                    </p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>

                <Reveal delay={0.1}>
                    <div className="mt-14 flex justify-center">
                        <a
                            href="#anfrage"
                            data-testid="amenities-inquiry-button"
                            className="inline-flex items-center gap-2 rounded-full bg-foreground text-background px-7 py-4 text-base font-medium hover:bg-foreground/90 transition-all duration-300 hover:-translate-y-0.5"
                        >
                            Jetzt unverbindlich anfragen
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
